<div class="text-center" [ngClass]="class">
	<div class="fst-italic gray-500 px-3 py-2">
		{{ message }}
	</div>

	<ng-content></ng-content>
</div>
